module.exports = __webpack_public_path__ + "static/media/aiDesignerAxisTemplate2.9783a81c.jpg";